'use client'

import React, { FC, ReactElement } from 'react'
import styles from './SatributePill.module.css'
import classnames from 'classnames'
import satributeSymbols from '@/utils/satribute-symbols'
import Modal from '@/components/satribute-modal'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const SatributePill: FC<{ className?: string; pillClassName?: string; sat?: string[] }> = (
	props
): ReactElement => {
	const { sat } = props
	const [open, setOpen] = React.useState(false)

	const satributes = satributeSymbols(sat as any)

	const handleClick = (evt: any) => {
		evt.stopPropagation()
		evt.preventDefault()
		setOpen(true)
	}

	const handleClose = (evt: any) => {
		evt.stopPropagation()
		evt.preventDefault()
		setOpen(false)
	}

	const renderSat = (s: any, i: any) => {
		return (
			<div key={i} className={styles.emoji}>
				{s}
			</div>
		)
	}

	return (
		<>
			<div
				className={classnames(
					{ [props?.pillClassName as any]: !!props?.pillClassName },
					{ [props?.className as any]: !!props?.className },
					'text-xs',
					'semibold',
					styles.root
				)}
				onClick={handleClick}
				role="button"
				tabIndex={0}
				onKeyDown={onKeyboardClick(handleClick)}
			>
				{satributes.map(renderSat)}
			</div>
			{open && <Modal open={open} onClose={handleClose} />}
		</>
	)
}

export default SatributePill
